import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/financials/export-excel`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportExcel = {
  get: apiPathFunc(pathBase),
};
